// extracted by mini-css-extract-plugin
export default {"tab__container":"styles_tab__container__-0ts4","tab__item":"styles_tab__item__CHqhk","tab__text":"styles_tab__text__-5867","tab__item--actived":"styles_tab__item--actived__oDN+4"};